import Vue from "vue";

export const dialogEvents = new Vue({ name: 'aufgabenpark-dialogs' });
